export function SetFileName(companyName: string, serviceYear: string, title: string, fileType: string){
    return `${companyName}_${serviceYear}_${title}.${fileType}`;
    
}